import React, { useState, useRef, useCallback } from "react";
import { useFlowStore } from "../../store/FlowStateStore.ts";

interface DynamicTextProps {
  placeholder: string;
  value: string;
  setValue: (val: string) => void;
  maxLength: number;
  removePad?: boolean;
}

const DynamicText: React.FC<DynamicTextProps> = ({ placeholder, value, setValue, maxLength, removePad = false }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const handlePointerDown = (e: React.PointerEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
  };

  return (
    <div className="dynamic-text-wrapper" style={{ position: 'relative' }}>
      <div className="dynamic-text" style={{ height: removePad ? '47px !important' : '' }}>
        <textarea
          ref={textareaRef}
          placeholder={placeholder}
          onChange={handleChange}
          onPointerDown={handlePointerDown}
          value={value}
          maxLength={maxLength}
        ></textarea>
        <div className="input-restriction">{(value?.length ?? 0)}/{maxLength}</div>
      </div>
    </div>
  );
}

export default DynamicText;
